export default __webpack_public_path__ + "images/23781a6699da5a777cf119ae03b6228b.svg";